import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import sage from "../../../images/splash/sage.jpeg";
import Nav from 'react-bootstrap/Nav';
import {Navbar,NavDropdown} from 'react-bootstrap';
import { Card, Form, Button, Table } from 'react-bootstrap';
import pro from "../../../images/splash/prof.png";
import axios from "axios";
import { var_api } from "../../constant";
import Modal from 'react-bootstrap/Modal';
import Loader from "../Loader";
import Pagination from 'react-js-pagination';
import React, { useState, useEffect,useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { Step } from '@material-ui/core';
import { parse } from 'handlebars';
import Select from 'react-select';

const EmployeeService = () => {
  const [totalEmployees, setTotalEmployee] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [show, setShow] = useState(false);
  const [isLogin, setIsLogin] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; 
   const [totalItems, setTotalItems] = useState(0);
  const [startIndex, setStartIndex] = useState(0);
  const [ searchQuery,setSearchQuery] = useState('');
  const [ roleToDelete,setRoleToDelete] = useState('');
  const [roles, setRoles] = useState([]);
  const [activeemployee, setactiveemployee] = useState([]);
  const [employeeserviceList, setemployeeserviceList] = useState([]);
  const history = useHistory();
  const [employeeid, setEmployeeid] = useState('');
  const [employeeName, setEmployeeName] = useState('');
  const [selectedEmployeeId, setSelectedEmployeeId] = useState('');
  const [selectedRole, setSelectedRole] = useState('');
  const [selectedRoleName, setSelectedRoleName] = useState('');
  const [currentRoleId, setCurrentRoleId] = useState(null);
  const [employeestatus, setemployeeStatus] = useState(null);
  const [errors, setErrors] = useState({});


  useEffect(() => {
    fetchEmployeeData();
    fetchRoleData();
    fetchactiveemployee();
}, [currentPage]);

const fetchactiveemployee = async () => {
  const token = localStorage.getItem('token');
  setIsLogin(true);
  try {
      const response = await axios.get(`${var_api}/api/employee/get-active-employees`, {
          headers: {
              'Authorization': `${token}`
          }
      });
      
      setactiveemployee(response.data);
      
      setIsLogin(false);
  } catch (error) {
    setactiveemployee([]);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
  }
};

const fetchRoleData = async () => {
  const token = localStorage.getItem('token');
  setIsLogin(true);
  try {
     const response = await axios.get(`${var_api}/api/sub-category-master/get`, { 
          headers: {
              'Authorization': `${token}`
          }
      });
      
      setRoles(response.data);
      
      setIsLogin(false);
  } catch (error) {
      setRoles([]);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
  }
};


// const fetchEmployeeData = async () => {
//   const token = localStorage.getItem('token');
//   setIsLogin(true);
//   try {
//      const response = await axios.get(`${var_api}/api/employee-services/get`, { 
//           headers: {
//               'Authorization': `${token}`
//           }
//       });
      
//       setemployeeserviceList(response.data);
      
//       setIsLogin(false);
//   } catch (error) {
//       setRoles([]);
//       if (error.response && error.response.status === 401) {
//         history.push('/signin');
//       } else {
//         Swal.fire({
//           icon: 'error',
//           title: 'Oops...',
//           text: error.response?.data?.error || 'Something went wrong!',
//           confirmButtonColor: '#007500',
//         });
//       }
//   }
// };


// Function to group employees by name and aggregate their services
const groupEmployeesByName = (employeeList) => {
  const groupedEmployees = employeeList.reduce((acc, employee) => {
    if (!acc[employee.emp_name]) {
      acc[employee.emp_name] = {
        ...employee,
        services: [],
      };
    }
    acc[employee.emp_name].services.push(employee.service_name);
    return acc;
  }, {});

  // Convert the object back to an array
  return Object.values(groupedEmployees).map(employee => ({
    ...employee,
    service_name: employee.services.join(', '), // Join services with a comma
  }));
};

// Fetch Employee Data and Group by Name
const fetchEmployeeData = async () => {
  const token = localStorage.getItem('token');
  setIsLogin(true);
  try {
    const response = await axios.get(`${var_api}/api/employee-services/get`, {
      headers: {
        Authorization: `${token}`,
      },
    });

    // Group employees by name
    const groupedData = groupEmployeesByName(response.data);
    setemployeeserviceList(groupedData);

    setIsLogin(false);
  } catch (error) {
    setemployeeserviceList([]);
    if (error.response && error.response.status === 401) {
      history.push('/signin');
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.response?.data?.error || 'Something went wrong!',
        confirmButtonColor: '#007500',
      });
    }
  }
};

const validateForm = () => {
  const newErrors = {};

  if (!employeeName) newErrors.employeeName = 'Employee Name is required';
  if (!selectedRole) newErrors.selectedRole = 'Service is required';

  return newErrors;
};


const handleOpenConfirmation = (employeeId) => {
    setRoleToDelete(employeeId);
    setShow(true);
};

const handleCloseConfirmation= ()=>{
    setShow(false)
  };
  const resetForm = () => {
    setEmployeeName('');
    setEmployeeid('');
    setSelectedRole('');
};

const handleDelete = async () => {
    const token = localStorage.getItem('token');
    setIsLogin(true);
    try {
        await axios.delete(`${var_api}/api/employee-services/delete/${roleToDelete}`, {
            headers: {
                'Authorization': `${token}`
            }
        });
        console.log('Role deleted successfully!');
        fetchEmployeeData();
        handleCloseConfirmation();
        setIsLogin(false);
    } catch (error) {
        console.error('Error deleting role:', error);
        if (error.response && error.response.status === 401) {
            history.push('/signin');
        }
    }
};

const createEmployee = async () => {
  const payload = {
    emp_id: parseInt(employeeid),
    emp_name: employeeName,
    service_id: parseInt(selectedRole),
    service_name: selectedRoleName,
  };

  const token = localStorage.getItem('token');  // Adjust the key as needed

  try {
    const response = await axios.post(`${var_api}/api/employee-services/post`,payload,
      {
        headers: {
          Authorization: `${token}`,  // Include the token in the Authorization header
        },
      }
    );
    console.log('Response:', response.data);
    fetchEmployeeData();
    resetForm();
    // Handle success actions, such as clearing the form or displaying a success message
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: 'Employee and Service details submitted successfully!',
    });
  } catch (error) {
    console.error('Error submitting data:', error);
    Swal.fire({
      icon: 'error',
      title: 'Submission Failed',
      text: 'There was an error submitting the data.',
    });
  }
};


  const handleSearchInput = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };
  
  // Filter employees before applying pagination
  const filteredEmployees = Array.isArray(employeeserviceList) && employeeserviceList.filter(employee => {
    const searchLower = searchQuery.toLowerCase();
    const matchesServices = employee.services?.some(service => 
      service.toString().toLowerCase().includes(searchLower)
    );
  
    
    return (
      (employee.emp_name?.toString().toLowerCase().includes(searchLower) || "") ||
      matchesServices
    );
  });
  
  
  // Apply pagination to the filtered list
  const paginatedFilteredEmployees = filteredEmployees.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  

     // Handler to update state when a role is selected
     const handleemployeeName = (selectedOption) => {
      if (selectedOption) {
        setEmployeeid(selectedOption.value); // Employee ID
        setEmployeeName(selectedOption.label); // Employee Name
      } else {
        setEmployeeid('');
        setEmployeeName('');
      }
    };

    const handleRoleChange = (selectedOption) => {
      if (selectedOption) {
        setSelectedRole(selectedOption.value); // Role ID
        setSelectedRoleName(selectedOption.label); // Role Name
      } else {
        setSelectedRole('');
        setSelectedRoleName('');
      }
    };
    
    
  // const handlePageChange = (pageNumber) => {
  //   setCurrentPage(pageNumber); // Update current page
  // };
  const handlePageChange = (pageNumber) => {
    // Ensure the page number doesn't exceed the total available pages
    const totalPages = Math.ceil(filteredEmployees.length / itemsPerPage);
    if (pageNumber > totalPages) {
      setCurrentPage(totalPages);
    } else {
      setCurrentPage(pageNumber);
    }
  };

  const handleRemoveService = (employeeId, serviceName) => {
    // Logic to remove the service from the employee
    setemployeeserviceList((prev) =>
      prev.map((employee) =>
        employee.id === employeeId
          ? {
              ...employee,
              services: employee.services.filter((service) => service !== serviceName),
            }
          : employee
      )
    );
  };
  

    return(
        <>
        {isLogin && <Loader />}
        <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
  <Navbar.Brand href="#home">
    <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
  <Nav className="mx-auto">
      <Nav.Link href="#" style={{ color: "black", fontSize:"25px", letterSpacing:"2px" }}>
       EMPLOYEE SERVICES
      </Nav.Link>
    </Nav>
    <Nav className="ms-auto">
      <Nav.Link href="/sb-home" style={{ color: "black", fontSize: "15px" }}>
        <button className="btn" style={{backgroundColor:"rgb(89, 128, 71)", color:"white"}}>
          <i className="bi bi-house"></i> Go to home
        </button>
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>
<br/>
<br/>
<br/>
<br/>
         <div style={{margin:"auto",padding:"20px"}}>
             <Row>
             <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
             <Card style={{ border: "none", maxWidth: "28rem", padding: "15px 27px", margin: "auto", height: "auto", borderRadius: "20px", boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgb(89, 128, 71, 0.50) 0px 3px 6px" }}>
            <Card.Body>
                <h5 style={{ textAlign: "center", color: "rgb(89, 128, 71)", fontWeight: "bold" }}>{editMode ? 'Edit Employee Service' : 'Create Employee Service'}</h5>
                <Form onSubmit={(e) => e.preventDefault()}>
                <Form.Group controlId="formBasicName" className="mt-3">
  <Form.Label>Employee Name</Form.Label>
  <Select
    value={
      employeeid
        ? { value: employeeid, label: employeeName } // Ensure value matches options' shape
        : null
    }
    onChange={(selectedOption) => {
      if (selectedOption) {
        setEmployeeid(selectedOption.value); // Update ID
        setEmployeeName(selectedOption.label); // Update Name
      } else {
        setEmployeeid('');
        setEmployeeName('');
      }
    }}
    options={activeemployee.map((employee) => ({
      value: employee.id,
      label: employee.name,
    }))}
    placeholder="Select Employee"
    isClearable
  />
  {errors.selectedEmployee && <p style={{ color: 'red' }}>{errors.selectedEmployee}</p>}
</Form.Group>
<Form.Group controlId="formBasicRole" className="mt-3">
  <Form.Label>Service Name</Form.Label>
  <Select
    value={
      selectedRole
        ? { value: selectedRole, label: selectedRoleName } // Ensure value matches options' shape
        : null
    }
    onChange={(selectedOption) => {
      if (selectedOption) {
        setSelectedRole(selectedOption.value); // Update ID
        setSelectedRoleName(selectedOption.label); // Update Name
      } else {
        setSelectedRole('');
        setSelectedRoleName('');
      }
    }}
    options={roles.map((role) => ({
      value: role.id,
      label: role.service_name,
    }))}
    placeholder="Select Service"
    isClearable
  />
</Form.Group>
                    {/* <Button variant="primary" type="submit" className="mt-3" style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)" }} onClick={employeeMasterpost}>
                        {editMode ? 'Update' : 'Submit'}
                    </Button>{" "} */}
                     <Button
      variant="primary"
      type="button"
      className="mt-3"
      style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)" }}
      onClick={createEmployee}
    >
      Submit
    </Button>{" "}

                    <Button variant="danger" type="button" className="mt-3" onClick={resetForm}>
                        Reset
                    </Button>
                </Form>
            </Card.Body>
        </Card>
</Col>
<Col xs={12} md={6} lg={6} xl={8} xxl={8} style={{padding:"0px",margin:"0px"}}>
                <Card style={{ border: "none", maxWidth:"62rem", padding:"20px", margin:"auto", height:"auto", borderRadius:"20px", fontFamily:"Arial, Helvetica, sans-serif" }}>
                 <h5 style={{color:"rgb(89, 128, 71)", fontWeight:"bold"}}>Employee Service List <span style={{float:"right", fontSize:"17px", color:"black", fontWeight:"bold"}}><Form.Control type="text" placeholder="Search..."  onChange={handleSearchInput}/></span> </h5>  
                 <div style={{float:"left"}}>
                    </div> 
                    
        <Table responsive className="mt-3">
          <thead>
            <tr>
              <th>S.No</th> 
              <th>Employee Name</th>
              <th>Service Name</th>
              {/* <th>Action</th> */}
            </tr>
          </thead>
          <tbody>
  {paginatedFilteredEmployees.length > 0 ? (
    paginatedFilteredEmployees.map((employee, index) => (
      <tr key={employee.id}>
       <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
        <td>{employee.emp_name}</td>
        <td>
  <div className="d-flex flex-wrap">
    {employee.services.map((service, serviceIndex) => (
      <div
        key={serviceIndex}
        className="card m-1"
        style={{
          position: "relative", // Make the card the reference for the button's absolute position
          padding: "10px", // Add padding to avoid overlap with the button
          border: "1px solid #ccc",
          borderRadius: "30px",
          boxShadow: "0px 1px 3px rgba(0,0,0,0.1)",
          // maxWidth: "200px",
          justifyContent:"space-between",
          margin: "5px",
          height: "auto",
          width: "auto",
        }}
      >
        <span style={{ fontSize: "0.9rem",marginRight:"20px" }}>{service}</span>
        <button
          className="btn-close"
          style={{
            position: "absolute", // Absolute positioning for top-right placement
            top: "10px", // Distance from the top
            right: "5px", // Distance from the right
            fontSize: "0.7rem",
            color: "white",
            backgroundColor: "red",
            border: "none",
            borderRadius: "50%", // Circular button
            width: "20px",
            height: "20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            marginLeft:"10px"
          }}
          onClick={() => handleOpenConfirmation(employee.id)}
          aria-label="Close"
        >
        </button>
      </div>
    ))}
  </div>
</td>

        {/* <td>
         
     <Button variant="primary" className="m-1" onClick={() => handleEdit(employee)}>
            <i className="bi bi-pencil-square"></i>
          </Button>
          <Button variant="danger" className="m-1" onClick={() => handleOpenConfirmation(employee.id)}>
            <i className="bi bi-trash"></i>
          </Button>

        </td> */}
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="7" className="text-center">No data available</td>
    </tr>
  )}
</tbody>
</Table>
<Pagination
  activePage={currentPage}
  itemsCountPerPage={itemsPerPage}
  totalItemsCount={filteredEmployees.length} // Update total count to reflect filtered data
  pageRangeDisplayed={5}
  onChange={handlePageChange}
  itemClass="page-item"
  linkClass="page-link"
  innerClass="pagination justify-content-end"
  activeClass="active-pagination"
/>
      </Card>
                </Col>
            </Row>
        </div>
        <Modal
        show={show}
        onHide={handleCloseConfirmation}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
        style={{ borderRadius: '20px' }} // Add border radius style
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(103, 120, 95, 0.367)",padding:"12px"}}>
          <Modal.Title  style={{fontFamily:"serif",fontWeight:"bolder",marginLeft:"190px"}}>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px",backgroundColor:"white"}}>
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure You want to Delete ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={handleCloseConfirmation}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
            Confirm
          </Button>
        </Modal.Body>
      </Modal>
        </>
    )
}

export default EmployeeService;